import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {AuthGuardGuard} from './guards/auth-guard.guard';
import {ConnectionGuard} from './guards/connection.guard';
import {UserControllerService} from './services/user/user-controller.service';
import {PublicationControllerService} from './services/publication/publication-controller.service';
import {DocumentControllerService} from './services/document/document-controller.service';
import {LibraryControllerService} from './services/library/library-controller.service';
import { VersionService } from './services/version/version.service';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [],
  providers: [
    AuthGuardGuard,
    ConnectionGuard,
    UserControllerService,
    PublicationControllerService,
    DocumentControllerService,
    LibraryControllerService,
    VersionService
  ]
})
export class CoreModule { }



// WEBPACK FOOTER //
// ./src/app/core/core.module.ts